import React from 'react';
import {
  Filter as RaFilter,
  DateInput,
  TextInput,
  SelectInput,
} from 'react-admin';
import { TRASACTION_STATUSES } from '../../../constants/statuses';

export const Filter = (props) => (
  <RaFilter {...props}>
    <DateInput label="Created from" alwaysOn source="createdAt||$gte" />
    <DateInput label="Created to" alwaysOn source="createdAt||$lt" />
    <TextInput label="Id" alwaysOn source="id||$eq" />
    <TextInput label="User ID" alwaysOn source="userId||$eq" />
    <TextInput label="Card ID" alwaysOn source="cards||$eq" />
    <SelectInput
      choices={TRASACTION_STATUSES}
      label="Statuses"
      source="statuses||$eq"
      alwaysOn
    />
    <TextInput label="Merchant" source="merchant||$eq" />
  </RaFilter>
);
